<template>
	<div class="row">
    <div class="col-md-12 text-center module-card" v-for="(el,ky) in main_content" :key="ky">
        <div class="blog-entry-sports animate-box">
           <!-- <a href="" class="blog-img" style="background-image: url(images/blog-1.jpg);">
            </a>--><p></p>
            <div class="desc">
               <!-- <p class="tag"><span>Nature</span></p>-->
                <h1 class="head-article" v-html="el['heading']"><a href="#" ></a></h1>
                <p>
                    <div class="side animate-box">                        
                        <p>
                            <ul class="category">
                                <li v-for="(content,k) in el['content']" :key="k">
                                   <!-- <a href="#" v-html="center['contentHeading']"><i class="icon-check"></i> </a>-->
                                    <router-link :to="'/content/'+content['id_cr']" v-html="content['title']" >
                        <!--<div class="text-left" :action="true"  ></div>-->
                                    </router-link>
                                </li>            
                            </ul>
                        </p>
                    </div>                                      
                </p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'mainContent',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN            
        };        
    },
    components:{
        
    },
    /*mounted :function(){
        this.showContent()
    },*/
     created :function(){
        this.showContent()
    },
    watch: {
        // call again the method if the route changes
        '$route': 'showContent'
    },
    
	methods:{
      showContent(){
            //console.log('okkkkkkk');
            this.$emit('content_ld_flagp_false')
            var module_id=this.$route.params.module_id
            var api_private_key=this.get_api_key_mix('mols')
          axios.get(this.$store.state.apiUrl+'/module_details',{
              params:{
                  id_module:'m'+module_id,
                  id_language:this.$store.state.companyData['id_language'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_country:this.$store.state.companyData['id_country'], 
                  id_eap:this.$store.state.companyData['id_eap'],
                  privatekey:api_private_key           
              }
          })
          .then(response => {
                response = response.data
                //console.log(response);
                this.main_content = response;
                this.$emit('content_ld_flagp_changed');               
                this.$nextTick(function () {
                })
              
          })
          .catch(() => {
                this.main_content = []
          });
      }

    }
};
</script>
<style scoped>
.module-card{
    background-color: #ffffff8f;;
    /*min-height: 450px;*/
        padding: 0 5px 5px 20px;
            text-align: left;
            
}

.side .category li a {
    border-bottom: 1px solid #f7f7f7ba;
}
/* 
.blog-entry .blog-img .desc {
    position: inherit;
} */

</style>